import { render, staticRenderFns } from "./InventoryDetailOff.vue?vue&type=template&id=61d773c8&scoped=true&"
import script from "./InventoryDetailOff.vue?vue&type=script&lang=js&"
export * from "./InventoryDetailOff.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDetailOff.vue?vue&type=style&index=0&id=61d773c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d773c8",
  null
  
)

export default component.exports